import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import {
  PaginatedOptions,
  PaginatedResults,
} from "@sdk/utils/paginated-results";
import axios, { AxiosResponse } from "axios";
import { UserTracker } from "user-tracker";
import {
  iWaHolidayNotificationWorkflow,
  iWaHolidayNotificationWorkflowInstance,
  iWaHolidayNotificationWorkflowInstanceData,
} from "./wa-holiday-notification-workflows-models";

export class WAHolidayNotificationWorkflowsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.waHolidayNotificationWorkflows.configure(config);
  }

  waHolidayNotificationWorkflows = Object.assign(
    new EntityServices<iWaHolidayNotificationWorkflow>(
      SDKConfig,
      "wa-holiday-notification-workflows",
      {
        onCreate: () => {
          UserTracker.track("WA HOLIDAY NOTIFICATION WORKFLOWS - Create", {});
        },
        onDelete: () => {
          UserTracker.track("WA HOLIDAY NOTIFICATION WORKFLOWS - Delete", {});
        },
      },
    ),
    {
      queryWaHolidayNotificationWorkflowContacts: async (
        query: any,
        options: PaginatedOptions,
      ) => {
        const results: AxiosResponse<
          PaginatedResults<iWaHolidayNotificationWorkflowInstance>
        > = await axios.post(
          this.config.basePath +
            `/wa-holiday-notification-workflows/query-contacts`,
          { query, options },
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      queryWaHolidayNotificationWorkflowContactsCount: async (req: {
        query: any;
      }) => {
        const results: AxiosResponse<{ count: number }> = await axios.post(
          this.config.basePath +
            `/wa-holiday-notification-workflows/query-contacts-count`,
          req,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      addContactToWaHolidayNotificationWorkflow: async (
        workflowId: string,
        req: {
          contactId: string;
          data: iWaHolidayNotificationWorkflowInstanceData;
        },
      ) => {
        UserTracker.track(
          "WA HOLIDAY NOTIFICATION WORKFLOWS - Add Contact to Workflow",
          {},
        );
        const results: AxiosResponse<any> = await axios.post(
          this.config.basePath +
            `/wa-holiday-notification-workflows/${workflowId}/contact`,
          req,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      stopAutomationInstance: async (
        workflowId: string,
        instanceId: string,
      ) => {
        UserTracker.track(
          "WA HOLIDAY NOTIFICATION WORKFLOWS - Stop Workflow Instance",
          {},
        );
        const results: AxiosResponse<any> = await axios.delete(
          this.config.basePath +
            `/wa-holiday-notification-workflows/${workflowId}/instances/${instanceId}`,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
    },
  );
}
